const Footer = () => {
  return (
    <footer>
      <div className="wrapper">
        <div className="footerLinks">
            <a href="https://junocollege.com/" target="blank" aria-label="Go to the Juno College website">Created at Juno College</a>
            <p>Created by <a href="https://github.com/duffymark" target="blank" aria-label="Go to Mark Duffy's Github Page">Mark Duffy</a></p>
          </div>
        </div>
    </footer>
  )
}

export default Footer;